import { cn } from '@/shared/lib/cn';

/**
 * Small chip for the `Tipo_RO` column distinguishing Ventas from
 * Cotizaciones. Ventas get a green chip (they generate revenue);
 * Cotizaciones get an amber chip (they're proposals, not yet income).
 * Any other value falls back to a neutral slate chip.
 */
export function TipoBadge({
  tipo,
  className,
}: {
  tipo: string | null | undefined;
  className?: string;
}) {
  const value = (tipo || '').toLowerCase();
  const isVenta = value === 'venta';
  const isCotizacion = value === 'cotizacion' || value === 'cotización';

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center whitespace-nowrap rounded-md px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide',
        isVenta
          ? 'bg-emerald-100 text-emerald-700'
          : isCotizacion
            ? 'bg-amber-100 text-amber-700'
            : 'bg-slate-100 text-slate-700',
        className,
      )}
    >
      {tipo || '—'}
    </span>
  );
}
